import { render, staticRenderFns } from "./BirgminghamCity.vue?vue&type=template&id=21109e07&scoped=true&"
import script from "./BirgminghamCity.vue?vue&type=script&lang=js&"
export * from "./BirgminghamCity.vue?vue&type=script&lang=js&"
import style0 from "./BirgminghamCity.vue?vue&type=style&index=0&id=21109e07&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21109e07",
  null
  
)

export default component.exports